import { RecallQueryParams } from '@customTypes/Recall'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { getGroupedAvailabilities } from 'src/services/api/availabilities'
import { CommonQueryParams } from './getQueryParams'
import { GetQueryKey } from './types'

type GetQueryKeyType = (
  commonParams: CommonQueryParams,
  recallQueryParams: RecallQueryParams | Record<string, string>
) => GetQueryKey<ReturnType<typeof getGroupedAvailabilities>>

export const getRecallQueryParams: GetQueryKeyType = (
  { clinicReferenceId },
  { treatmentBundleTypeReferenceId, customerId, practitionerReferenceId }
) => {
  const queryParams = {
    clinicReferenceId,
    treatmentBundleReferenceId: treatmentBundleTypeReferenceId,
    patientType: PatientTypeOptions.OLD,
    customerId,
    practitionerReferenceIds: practitionerReferenceId ? [practitionerReferenceId] : undefined,
  }

  return [['recallAvailabilities', queryParams], ({ pageParam }) => getGroupedAvailabilities(queryParams, pageParam)]
}
